import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import LoginPage, { getDefaultPageData } from "components/pages/LoginPage";
import React from "react";

/**
 * @name CaptureFirstLoginPasswordEntered
 * @returns {React.Component}
 * @description Capture component to show the login page with the user
 * id and password filled out. For the first time login group
 */
export default function CaptureFirstLoginPasswordEntered(props) {
    // initalize a new instance of BCMSStateManagerCRUD using the default page data
    // then update the userID and password properties
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "userID" ], "DemoUser")
        .update([ "password" ], "123456789")
        .submit();

    // Return the login page passing the data variable
    return <LoginPage data={ data } />
}